const routes = [
    {
        name: 'home',
        path: '/',
        component: () => import('@/views/search/Index.vue'),
    },
];

export default routes;
